var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wallet" },
    [
      _c("div", { staticClass: "wallet_detail_box" }, [
        _c("table", { staticClass: "list" }, [
          _vm._m(0),
          _c(
            "tbody",
            _vm._l(_vm.walletData.data.list, function (item, index) {
              return _c("tr", { key: index }, [
                _c("td", [_vm._v(_vm._s(item.id))]),
                _c("td", [_vm._v(_vm._s(item.sender))]),
                _c("td", [_vm._v(_vm._s(item.receiver))]),
                _c("td", [_vm._v(_vm._s(item.itemName))]),
                _c("td", [_vm._v(_vm._s(item.price))]),
                _c("td", [_vm._v(_vm._s(item.statusDesc))]),
                _c("td", [
                  _c("span", { staticClass: "time" }, [
                    _vm._v(_vm._s(item.createTime)),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ]),
        !_vm.walletData.data.list.length
          ? _c("div", { staticClass: "none-item" }, [
              _c("div", [_vm._v("暂无数据")]),
              _c("img", {
                attrs: {
                  src: require("@/assets/images/none-item.svg"),
                  alt: "",
                },
              }),
            ])
          : _vm._e(),
      ]),
      _c("Page", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.walletData.data.total > _vm.walletData.size,
            expression: "walletData.data.total > walletData.size",
          },
        ],
        attrs: {
          current: _vm.walletData.current,
          total: _vm.walletData.data.total,
          "page-size": _vm.walletData.size,
          "class-name": "page",
        },
        on: {
          "update:current": function ($event) {
            return _vm.$set(_vm.walletData, "current", $event)
          },
          "on-change": _vm.pageF,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("流水号")]),
        _c("th", [_vm._v("发送方")]),
        _c("th", [_vm._v("接收方")]),
        _c("th", [_vm._v("物品")]),
        _c("th", [_vm._v("物品价值")]),
        _c("th", [_vm._v("状态")]),
        _c("th", [_vm._v("时间")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }